/**
 * Notice: Some code was adapted from Material-UI's TextField component.
 *         Copyright (c) 2014 Call-Em-All (https://github.com/callemall/material-ui)
 */
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import useTheme from 'client/util/useTheme';
import FormsyText from 'components/FormsyText/FormsyText';
import React, { forwardRef, useEffect, useState } from 'react';

const getStyles = (props, theme, state) => {
  const {
    palette: {
      disabledColor,
      error,
    },
  } = theme;

  const styles = {
    root: {
      position: 'relative',
      display: props.fullWidth ? 'block' : 'inline-block',
    },
    input: {
      boxSizing: 'border-box',
    },
    hint: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: props.errorText ? error.main : alpha(disabledColor, 0.5),
      transition: theme.transitions.easing.easeOut,
    },
    error: {
      color: error.main,
    },
  };

  return styles;
};

const FormsyPassword = (props, ref) => {
  const [visible, setVisible] = useState(props.visible);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);


  const toggleVisibility = () => {
    setVisible(v => !v);
  };

  const handleInputFocus = (event) => {
    setFocused(true);
    if (props.onFocus) {
      props.onFocus(event);
    }
  };

  const handleInputBlur = (event) => {
    setFocused(false);
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  const {
    disableButton,
    errorText,
    errorStyle,
    hintText,
    style: {
      width = props.fullWidth ? '100%' : 'inherit',
      ...otherStyle
    } = props.style || {},
    textFieldStyle,
      type, // eslint-disable-line
      visible: visibleProp, // eslint-disable-line
    ...other
  } = props;

  const theme = useTheme();

  const styles = getStyles(props, theme, { focused, visible });

  const { prepareStyles } = theme;
  const actualErrorText = errorText || hintText;

  return (
    <div style={{ ...styles.root, width, ...otherStyle }}>
      <FormsyText
        {...other}
        ref={ref}
        errorText={errorText}
        hintText={null}
        style={{ ...styles.input, width, ...textFieldStyle }}
        type={visible ? 'text' : 'password'}
        onFocus={event => handleInputFocus(event)}
        onBlur={event => handleInputBlur(event)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => toggleVisibility()}
                onMouseDown={e => e.preventDefault()}
                disabled={disableButton || other.disabled}
                tabIndex={-1}
                size="large"
              >
                {visible ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {hintText && !errorText ? <div style={prepareStyles(styles.hint)}>{actualErrorText}</div> : null}
    </div>
  );
};

export default forwardRef(FormsyPassword);
